import script from "./MobileVersion.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileVersion.vue?vue&type=script&setup=true&lang=ts"

import "./MobileVersion.vue?vue&type=style&index=0&id=546d2faf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-546d2faf"]])

export default __exports__